import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Grid, makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import {
  Label as LabelIcon,
  DynamicFeed as DynamicFeedIcon,
  AttachMoney,
  Receipt as ReceiptIcon,
  Assignment as AssignmentIcon,
  Description as DescriptionIcon,
  Web as WebIcon,
  TableChart as TableChartIcon,
  FileCopy,
  InsertDriveFile,
  DashboardOutlined as DashboardIcon,
  Flight as FlightIcon,
  DirectionsBoat as DirectionsBoatIcon,
} from '@material-ui/icons';
import { Calculate as CalculateIcon } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import QCXMainLayout from '../../../../components/main-layout/QCXMainLayout';
import QCXCardMenu from '../../../../shared-components/card-menu/QCXCardMenu';
import { IMPORTACAO_MODULE } from '../../../../utils/general/modules';
import { focusLockActions } from '../../../../features/focus-lock/focusLockSlice';
import QCXFocusLock from '../../../../components/focus-lock/QCXFocusLock';
import NumerarioImportacaoUtils from '../../../../utils/general/numerario-importacao/NumerarioImportacaoUtils';

const useStyles = makeStyles((theme) => ({
  cardMenuContainer: {
    marginTop: theme.spacing(0),
  },
  cardMenu: {
    width: theme.spacing(100),
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  subNested: {
    paddingLeft: theme.spacing(8),
  },
  active: {
    display: 'flex!important',
  },
  noActive: {
    display: 'none!important',
    transformOrigin: '0 0 0!important',
  },
}));

export default function PricingTarifarioModulePage({ authInfo = {} }) {
  const { t } = useTranslation();
  const classes = useStyles();

  const dispatch = useDispatch();
  const userHasAnyRole = (mainRoles = []) =>
    authInfo.roles.some((role) => mainRoles.find((item) => role.startsWith(item)));
  const {
    location: { pathname: currentLocationPath },
  } = useHistory();

  useEffect(() => {
    const handleFocusLock = () => {
      const currentPaths = currentLocationPath.split('/');

      const match = (modulePaths) => modulePaths.every((path) => currentPaths.includes(path));

      if (match(IMPORTACAO_MODULE)) {
        dispatch(focusLockActions.lock());
      }
    };

    handleFocusLock();
  }, [currentLocationPath]);

  const breadcrumbs = [
    {
      link: {
        to: '/',
        name: t('com.muralis.qcx.inicio'),
      },
    },
    {
      text: {
        name: t('com.muralis.qcx.importacao.label'),
      },
    },
  ];

  return (
    <QCXMainLayout
      pageIcon={<LabelIcon />}
      pageTitle={t('com.muralis.qcx.importacao.label')}
      breadcrumbs={breadcrumbs}
      authInfo={authInfo}
    >
      <Grid className={classes.cardMenuContainer} item container justify="center" xs={12} sm={12} md={12} xl={12}>
        <QCXFocusLock>
          <Grid container style={{ maxWidth: '1920px' }}>
            {userHasAnyRole(['importacao-follow-up']) && (
              <Grid item justify="center" xs={6} sm={4} md={3} lg={3} xl={2} className={classes.active}>
                <QCXCardMenu
                  title={t('com.muralis.qcx.pricingModule.tarifarioMaritimoLabel')}
                  link={t('com.muralis.qcx.url.tarifarioMaritimo')}
                  icon={DirectionsBoatIcon}
                />
              </Grid>
            )}

            {userHasAnyRole(['importacao-follow-up']) && (
              <Grid item justify="center" xs={6} sm={4} md={3} lg={3} xl={2} className={classes.active}>
                <QCXCardMenu
                  title={t('com.muralis.qcx.pricingModule.tarifarioAereoLabel')}
                  link={t('com.muralis.qcx.url.tarifarioAereo')}
                  icon={FlightIcon}
                />
              </Grid>
            )}

          </Grid>
        </QCXFocusLock>
      </Grid>
    </QCXMainLayout>
  );
}
